// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__tXVra","Block":"Menu_Block__2htqr","Legend":"Menu_Legend__Hi0Dj"};